import React from "react";
import { useFormContext } from "react-hook-form";
const ErrorPanel = ({ name }) => {
    var _a, _b, _c;
    const { formState: { errors } } = useFormContext();
    return (React.createElement(React.Fragment, null, errors[name] && typeof ((_a = errors[name]) === null || _a === void 0 ? void 0 : _a.message) === "string" && (React.createElement("span", { className: "invalid-feedback d-block" }, (_c = (_b = errors[name]) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.toString()))));
};
export default ErrorPanel;
